import React from "react";

import DateBoxes from "./components/Date-boxes/DateBoxes";
import DiaryLinks from "./components/DiaryLinks";

const ClientDiaryPage: React.FC = () => {
  return <DateBoxes LinksComponent={<DiaryLinks />} />;
};

export default ClientDiaryPage;
